import React from 'react';
import { Button, ButtonProps } from '@mui/material';

/**
 * Bouton secondaire clair pour les en-têtes de page (thème harmonisé accueil).
 * Remplace les boutons « verre » (fond rgba blanc) des anciens PageHeader sombres.
 */
const AppOutlineButton: React.FC<ButtonProps> = ({ sx, ...props }) => (
  <Button
    variant="outlined"
    size="small"
    {...props}
    sx={[
      {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 2,
        px: 1.75,
        borderColor: '#d0d5dd',
        color: '#344054',
        bgcolor: '#fff',
        '&:hover': { borderColor: '#98a2b3', bgcolor: '#f4f5f7' },
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  />
);

export default AppOutlineButton;
